import service from "../services/settings.service";

export const settings = {
    namespaced: true,
    state: {
        settings: null,
    },
    getters: {
        manageProduction: (state) => {
            if (!state.settings || state.settings.manage_production === undefined || state.settings.manage_production === null) {
                return true;
            }
            return !!state.settings.manage_production;
        },
    },
    actions: {
        async get({ commit }, data) {
            try {
                const response = await service.get(data);
                commit("SET_SETTINGS", response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save({ commit }, data) {
            try {
                const response = await service.updateData(data);
                commit("SET_SETTINGS", response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            state.settings = settings;
        },
    },
};
